import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _get from "lodash/get";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import fetch from 'cross-fetch';
import { setContext } from '@apollo/client/link/context'; // @ts-ignore: No types yet :(

import { getCoreHTTPHeaders } from '@nerdwallet/nw-api-sdk/headers';
import config from '@nerdwallet/app-config';
import defaultTypePolicies from '../type-policies';
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, onError } from '../index';
import introspectionResult from '../generated-gql/possible-types';

/**
 * Returns the possibleTypes for fragments.
 * If one is provided in apolloOptions, that will be used.
 * Otherwise, one will be generated using the generated-gql possibleTypes.
 * To update the default data, run `npm run generate-possible-types`.
 */
export var getPossibleTypes = function getPossibleTypes(options) {
  return options.possibleTypes || introspectionResult.possibleTypes;
};
/**
 * Returns the typePolicies for fragments.
 * If one is provided in apolloOptions, that will be used.
 */

export var getTypePolicies = function getTypePolicies(options) {
  return options.typePolicies || defaultTypePolicies;
};
/**
 * Instantiates an apollo-client integration with query0.
 */

export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var options,
      possibleTypes,
      typePolicies,
      headers,
      serverRequest,
      _options$cache,
      cache,
      fetchOption,
      _options$log,
      log,
      apolloOptions,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          possibleTypes = getPossibleTypes(options);
          typePolicies = getTypePolicies(options);
          headers = options.headers, serverRequest = options.serverRequest, _options$cache = options.cache, cache = _options$cache === void 0 ? new InMemoryCache({
            possibleTypes: possibleTypes,
            typePolicies: typePolicies
          }) : _options$cache, fetchOption = options.fetch, _options$log = options.log, log = _options$log === void 0 ? function () {} : _options$log, apolloOptions = _objectWithoutProperties(options, ["headers", "serverRequest", "cache", "fetch", "log"]);
          return _context2.abrupt("return", new ApolloClient(_objectSpread(_objectSpread({}, apolloOptions), {}, {
            cache: cache,
            // This enables us to know things such as which clients call deprecated APIs
            name: config.CLIENT_ID,
            version: _get(config, '_meta.version'),
            link: ApolloLink.from([onError(function (_ref2) {
              var graphQLErrors = _ref2.graphQLErrors,
                  networkError = _ref2.networkError;

              if (graphQLErrors) {
                graphQLErrors.map(function (_ref3) {
                  var message = _ref3.message,
                      locations = _ref3.locations,
                      path = _ref3.path;
                  return log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
                });
              }

              if (networkError) log("[Network error]: ".concat(networkError));
            }), // Avoid outdated header tokens by refetching headers asynchronously on
            // request to prevent stale data from cached security tokens. These will
            // get set as context.headers which is used by apollo-link-http:
            // https://github.com/apollographql/apollo-link/blob/a204a87e9e8c2ff9d4f797e1b17b843078aa5622/packages/apollo-link-http/src/httpLink.ts#L84
            // https://nerdwallet.atlassian.net/browse/FEI-847
            setContext( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              var coreHeaders;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return getCoreHTTPHeaders({
                        serverRequest: serverRequest,
                        config: {
                          applicationID: config.APPLICATION_ID,
                          clientID: config.CLIENT_ID
                        }
                      });

                    case 2:
                      coreHeaders = _context.sent;
                      return _context.abrupt("return", {
                        headers: coreHeaders
                      });

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))), new HttpLink({
              uri: config.API.BASE_URLS.QUERY0,
              // Use `credentials: include` to allow for cross-origin requests to
              // include cookies. For example, when making a cross-origin request
              // from localnerd.nerdwallet.com to api.nerdwallet.biz, this allows
              // requests to include cookies set for api.nerdwallet.biz. Without
              // `credentials: include`, no cookies would be sent. This allows
              // local development against stage or prod query0.
              credentials: 'include',
              headers: _objectSpread(_objectSpread({}, headers), {}, {
                // Since this code is designed to be isomorphic, we'll set a
                // different platform ID depending on if we're executing on a
                // server (SSR) or on a client. Note that query0 will refuse
                // requests without a valid client ID specified in this header.
                'X-Client-Platform': serverRequest ? 'server' : 'web'
              }),
              fetch: fetchOption || fetch
            })].filter(Boolean))
          })));

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
}));